import { Select } from "semantic-ui-react";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {
  behalfOfKeyValue,
  getBulkDropdownData,
  getDropdownData,
  getOtherRefSearchDropdown,
  getTextByValueAndKey,
} from "../../../api/keyvalue";
import SearchDropdown from "../../input/SearchDropdown";
import { getBehalfOf } from "../../../api/systemUserApi";
import Button from "../../input/Button";
import { Search } from "react-feather";
import LoadingSpinner from "../../LoadingSpinner";
import Grid from "../../Grid";
import { ActiveCellStyle, StatusCellStyle } from "../../renderer/StyleRenderer";
import { stakeholderById } from "../../../api/stakeholderapi";
import {
  getUserCustomerByUserId,
  searchUserCustomer,
} from "../../../api/UserCustomerApi";
import Dropdown from "../../input/Dropdown";

const UserCustomerSearch = ({
  setUserCustomerSearchRes,
  setUscSearchSubmitLoading,
  setUscSearchClicked,
}) => {
  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [stkFieldReset, setStkFieldReset] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [resetVisible, setResetVisible] = useState(false);

  const [activeAccordion1, setActiveAccordion1] = useState(true);

  //search states
  const [user, setUser] = useState("");
  const [stakeholder, setStakeholder] = useState("");
  const [status, setStatus] = useState(null);
  const [active, setActive] = useState(null);
  const [stakeholderType, setStakeholderType] = useState(null);
  const [selectedStakeholder, setSelectedStakeholder] = useState([]);

  //search dropdowns
  const [activeOptions, setActiveOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [stakeTypeOptions, setStakeTypeOptions] = useState([]);

  useEffect(() => {
    (async () => {
      //new

      const {
        active,
        status,
        stakeholder_type: stakeholderTypeOpt,
      } = await getBulkDropdownData([
        { key: "active" },
        { key: "status" },
        { key: "stakeholder_type" },
      ]);

      setActiveOptions(active);
      setStatusOptions(status);
      setStakeTypeOptions(stakeholderTypeOpt);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const selectedStakeholder = await getTextByValueAndKey(
        "stakeholder_type",
        stakeholderType
      );
      setSelectedStakeholder(selectedStakeholder);
    })();
  }, [stakeholderType]);

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    setActiveAccordion1(false);
    setResetVisible(true);
    setUscSearchSubmitLoading(true);
    setUscSearchClicked(true);

    const response = await searchUserCustomer({
      uscUserId: user ? user : null,
      uscStkType: stakeholderType ? stakeholderType : null,
      uscStakeholder: stakeholder ? stakeholder : null,
      status: status !== null && status !== undefined ? status : null,
      active: active !== null && active !== undefined ? active : null,
    });

    setUserCustomerSearchRes(response);
    setUscSearchSubmitLoading(false);
  };
  const handleSearchReset = (e) => {
    e.preventDefault();
    setSearchFieldReset(true);
    setStatus(null);
    setActive(null);
    setUser("");
    setStakeholder("");
    setStakeholderType(null);
    setStkFieldReset(true);
  };

  const handleReset = (e) => {
    e.preventDefault();
    handleSearchReset(e);
  };

  return (
    <>
      <div className="ui styled accordion" style={{ width: "100%" }}>
        <div
          className={`title ${activeAccordion1 ? "active" : ""}`}
          onClick={() => setActiveAccordion1(!activeAccordion1)}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <span>Search</span>
              <Search size={14} style={{ marginLeft: "10px" }} />
              <i className="dropdown icon"></i>
            </div>

            <i
              className="refresh icon primary button"
              style={{
                display: `${resetVisible ? "flex" : "none"}`,
                cursor: "pointer",
              }}
              onClick={(e) => {
                handleReset(e);
              }}
            ></i>
          </div>
        </div>
        <div className={`content ${activeAccordion1 ? "active" : ""}`}>
          {isSearchLoading ? (
            <LoadingSpinner />
          ) : (
            <form className="ui form">
              <h4 className="ui dividing header"></h4>
              <div className="five fields">
                <SearchDropdown
                  key={1}
                  threshold={1}
                  editMode={false}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  api={getBehalfOf}
                  apiDependency={{
                    customer: null,
                    shipper: null,
                  }}
                  onResultSelect={(data) => setUser(data)}
                  onClear={() => {
                    setUser("");
                  }}
                  label="User"
                />

                <Dropdown
                  label="Stakeholder Type"
                  placeholder="Stakeholder Type"
                  options={stakeTypeOptions}
                  value={stakeholderType}
                  onChange={(e, data) => {
                    setStakeholderType(data.value);
                    setStkFieldReset(true);
                    setStakeholder("");
                  }}
                />

                <SearchDropdown
                  key={1}
                  editMode={false}
                  reset={stkFieldReset}
                  setReset={setStkFieldReset}
                  clearable={true}
                  onClear={() => {
                    setStakeholder("");
                  }}
                  onResultSelect={(data) => setStakeholder(data)}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: selectedStakeholder,
                  }}
                  label="Stakeholder"
                />
                <Dropdown
                  label="Status"
                  options={statusOptions}
                  placeholder="Status"
                  style={{ height: "20px" }}
                  value={status}
                  onChange={(e, data) => {
                    setStatus(data.value);
                  }}
                />
                <Dropdown
                  label="Active"
                  options={activeOptions}
                  placeholder="Active"
                  style={{ height: "20px" }}
                  value={active}
                  onChange={(e, data) => {
                    setActive(data.value);
                  }}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div className="field" style={{ width: "100%" }}>
                  <Button
                    template="search"
                    onClick={(e) => {
                      handleSearchSubmit(e);
                    }}
                  />
                  <Button
                    template="searchReset"
                    onClick={(e) => {
                      handleSearchReset(e);
                    }}
                  />
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
};
export default UserCustomerSearch;


